import axios from 'axios'
import { API_URL } from '@/const'
import { store } from '@/store'

export const getAxiosBroadcast = async (id) => {
  try {
    const { accessToken } = store.state.app.user
    const headers = {
      Authorization: `Bearer ${accessToken}`
    }
    const { data } = await axios.get(`${API_URL.BROADCAST_V1}/${id}`, { headers })
    return data.name
  } catch (e) {
    console.log(e.response.data)
  }
  return ''
}
